import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@core/services/api.service';
import { NextStep } from '@shared/models/next-step';
import { PaginationState } from '@shared/models/pagination-state';
import { NextStepFilters } from '@shared/models/next-step-filters';
import { Sorting } from '@shared/models/sorting';

@Injectable({
  providedIn: 'root',
})
export class NextStepsApiService {
  constructor(private apiService: ApiService) {}

  index(
    paginationState: Partial<PaginationState>,
    filters: NextStepFilters,
    sorting: Sorting,
  ): Observable<{ data: NextStep[]; meta: PaginationState }> {
    let params = {
      ...filters,
      page: paginationState.page,
      per_page: paginationState.per_page,
      sort: `${sorting.key}`,
      sort_direction: `${sorting.direction}`,
    };
    return this.apiService.get('v1/next_steps', params);
  }

  create(nextStep: Partial<NextStep>): Observable<{ data: NextStep }> {
    return this.apiService.post(`v1/next_steps`, { data: nextStep });
  }
}
